import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmDropdownMenuImports } from '@spartan-ng/helm/dropdown-menu';
import { AuthService } from 'src/app/authentication/auth.service';

@Component({
	selector: 'app-language-switcher',
	imports: [HlmDropdownMenuImports, HlmButtonImports],
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `
    <button hlmBtn variant="outline" [hlmDropdownMenuTrigger]="menu" align="start" class="flex items-center gap-2">
      <span><img src="assets/flags/{{activeLangId()}}.svg" width="16" alt="{{activeLangId()}}" /></span>
      <span class="hidden max-w-[min(11rem,calc(100vw-7rem))] min-w-0 truncate text-sm sm:block font-normal align-top">
        {{activeLangName()}}
      </span>
    </button>
		<ng-template #menu>
			<hlm-dropdown-menu class="w-38">
				<hlm-dropdown-menu-group>
					@let l = activeLangId();
          @for(lang of languages; track lang){
            <button hlmDropdownMenuRadio [keepOpen]="false" [checked]="l === lang.id" (triggered)="setLanguage(lang)">
              <img src="assets/flags/{{ lang.id }}.svg" width="20" alt="{{ lang.id }}" />
              {{ lang.name }}
              <hlm-dropdown-menu-radio-indicator />
            </button>
          }
				</hlm-dropdown-menu-group>
			</hlm-dropdown-menu>
		</ng-template>
	`,
})
export class LanguageSwitcher {

  private readonly authService = inject(AuthService);

	protected readonly activeLangId = signal(localStorage.getItem('locale') ?? 'en');
  protected readonly activeLangName = computed(() => {
    const lang = this.languages.find(l => l.id === this.activeLangId());
    return lang ? lang.name : '';
  });

  protected languages = [
    { id: 'en', name: 'English', active: false },
    { id: 'es', name: 'Español', active: false },
    { id: 'fr', name: 'Français', active: false },
    { id: 'de', name: 'Deutsch', active: false },
    { id: 'it', name: 'Italiano', active: false },
  ];

  protected async setLanguage(lang:any){
    this.activeLangId.set(lang.id);
    localStorage.setItem('locale', lang.id);
    await this.authService.loadLanguages();
  }
}